export default "You must order a minimum of 10 club kit items to continue\n"